import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { useMediaQuery } from 'react-responsive';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;

function Base(props) {
	const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
	return (
		<Grid
			alignItems="center"
			className={props.classes.root}
			container
			justify="center"
			spacing={2}
			style={{ imarginTop: isMobile ? '0px' : '8%' }}>
			<Grid item sm={isMobile ? 12 : 9} xs={isMobile ? 12 : 10}>
				<div className="mobile-container">
					<Paper className={props.classes.paper}>
						<Grid className={props.classes.root} container>
							{' '}
							{props.children}
						</Grid>
					</Paper>
				</div>
			</Grid>
		</Grid>
	);
}

export default Base;
